var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('circle',{pre:true,attrs:{"cx":"5","cy":"12","r":"2.1"}}),_c('circle',{pre:true,attrs:{"cx":"12","cy":"12","r":"2.1"}}),_c('circle',{pre:true,attrs:{"cx":"19","cy":"12","r":"2.1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }